import type { TagVariants } from '@lemonade-hq/uniclient-theme';

export type TagProps = TagVariants & { readonly content: string };
export type TagComposerProps = TagProps & { readonly type: 'tag' };

export function tag(props: TagProps): TagComposerProps {
  return { ...props, type: 'tag' };
}
